// extracted by mini-css-extract-plugin
module.exports = {"banner":"index-module--banner--3VSSa"};